"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyUser = exports.userLoginSagas = void 0;
var effects_1 = require("redux-saga/effects");
var LoginState_1 = require("@/pages/common/states/LoginState");
var UserAction_1 = require("@/pages/common/actions/UserAction");
var LoginAction_1 = require("@/pages/common/actions/LoginAction");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var LoginApiSaga_1 = require("@/pages/common/sagas/api/LoginApiSaga");
var FacebookApi_1 = require("@/api/vendor/FacebookApi");
var RootSaga_1 = require("@/pages/common/sagas/RootSaga");
var ExistingLoginAction_1 = require("@/pages/search/actions/sfilter/ExistingLoginAction");
var Pages_1 = require("@/rendering/common/Pages");
var EnquireSagaCall_1 = require("@/pages/search/sagas/EnquireSagaCall");
var LoginCallSaga_1 = require("@/pages/common/sagas/LoginCallSaga");
var Analytics_1 = require("@/api/vendor/Analytics");
var getIsFromLoginPopup = function (state) { return state.page !== Pages_1.Pages.ACCOUNT_LOGIN; };
var isLoginPanelActive = function (state) {
    return state.login.isActive && state.login.isDim;
};
var getFacebookAppId = function (state) {
    return state.login.facebookAppId;
};
var checkHasResumeState = function (state) {
    return state.layout.returnState;
};
var getEmptyUser = function () { return ({
    id: '',
    email: '',
    firstname: '',
    lastname: '',
    salutation: LoginState_1.Salutation.NONE,
    phone: '',
    subscribed: false,
    from: '',
    isConfirmed: false,
    countryCode: ''
}); };
exports.getEmptyUser = getEmptyUser;
var watchTopMenuLoginClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(LayoutAction_1.default.ON_TOPMENU_LOGIN_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.togglePanelActive())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchLoginCloseClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(LoginAction_1.default.ON_LOGIN_CLOSE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.togglePanelActive())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchTogglePanelActive = function () {
    var isActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.take(LoginAction_1.default.TOGGLE_LOGIN_PANEL_ACTIVE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(isLoginPanelActive)];
            case 2:
                isActive = _a.sent();
                console.log('isActive', isActive);
                if (!isActive) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setReturnState(''))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.setPanelActive(false))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.setPanelDim(false))];
            case 6:
                _a.sent();
                return [3 /*break*/, 11];
            case 7: return [4 /*yield*/, effects_1.put(LoginAction_1.default.setPanelDim(true))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.setPanelActive(true))];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
var watchLoginSubmit = function () {
    var payload, fields, languageCode, response, returnState, isFromLoginPopup, returnUrl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 21];
                return [4 /*yield*/, effects_1.take(LoginAction_1.default.ON_LOGIN_SUBMIT)];
            case 1:
                payload = (_a.sent()).payload;
                fields = payload;
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.setLoading(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 3:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(LoginApiSaga_1.loginApi, fields, languageCode)];
            case 4:
                response = _a.sent();
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.setLoading(false))];
            case 5:
                _a.sent();
                if (!!response) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.setGlobalError('apiCallError'))];
            case 6:
                _a.sent();
                return [3 /*break*/, 20];
            case 7:
                if (!!response.data.user) return [3 /*break*/, 10];
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.setGlobalError(response.data.result.message))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.saveSearchSetToLocalStorage(fields.email))];
            case 9:
                _a.sent();
                return [3 /*break*/, 20];
            case 10: return [4 /*yield*/, effects_1.select(RootSaga_1.getReturnState)];
            case 11:
                returnState = _a.sent();
                return [4 /*yield*/, effects_1.select(getIsFromLoginPopup)];
            case 12:
                isFromLoginPopup = _a.sent();
                if (!isFromLoginPopup) return [3 /*break*/, 17];
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.togglePanelActive())];
            case 13:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 14:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setReturnState(returnState))];
            case 15:
                _a.sent();
                return [4 /*yield*/, effects_1.call(LoginCallSaga_1.setUserFromRemote, response.data.user)];
            case 16:
                _a.sent();
                return [3 /*break*/, 0];
            case 17: return [4 /*yield*/, effects_1.call(WindowApi_1.getReturnUrl)];
            case 18:
                returnUrl = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, returnUrl)];
            case 19:
                _a.sent();
                _a.label = 20;
            case 20: return [3 /*break*/, 0];
            case 21: return [2 /*return*/];
        }
    });
};
var watchOnFacebookLogin = function () {
    var isGuest, token, appId, returnState, lang;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(LoginAction_1.default.FACEBOOK_LOGIN)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuest = _a.sent();
                if (!isGuest)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(FacebookApi_1.getToken)];
            case 3:
                token = _a.sent();
                if (!!token) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.select(getFacebookAppId)];
            case 4:
                appId = _a.sent();
                return [4 /*yield*/, effects_1.select(RootSaga_1.getReturnState)];
            case 5:
                returnState = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 6:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.call(FacebookApi_1.showLoginDialog, appId, lang, returnState)];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
var watchLoginUploadSaveSearchFromLocalStorageSaga = function () {
    var payload, hasResumeState, user;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(UserAction_1.default.SET_USER)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.select(checkHasResumeState)];
            case 2:
                hasResumeState = _a.sent();
                user = payload;
                if (!hasResumeState) return [3 /*break*/, 4];
                // User has explicily invoke save search, so just pop LocalStorage, and
                // leave the invoke method to trigger save search on its own resume state
                // procedure
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.popSaveSearchFromLocalStorage)];
            case 3:
                // User has explicily invoke save search, so just pop LocalStorage, and
                // leave the invoke method to trigger save search on its own resume state
                // procedure
                _a.sent();
                _a.label = 4;
            case 4:
                if (!(user.id && user.email && !hasResumeState)) return [3 /*break*/, 6];
                // User is logging in, Pop LocalStorage and sync to server
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.saveSearchFromLocalStorage)];
            case 5:
                // User is logging in, Pop LocalStorage and sync to server
                _a.sent();
                _a.label = 6;
            case 6: return [4 /*yield*/, effects_1.put(UserAction_1.default.setUserDone(user))];
            case 7:
                _a.sent();
                return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchLoginCloseClickClearEmailSaga = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(LoginAction_1.default.ON_LOGIN_CLOSE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.setEmail(''))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExistingLoginAction_1.default.setEmail(''))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExistingLoginAction_1.default.setLoginProvider(''))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchUserLoginInitTrackingUserId = function () {
    var payload, user;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(UserAction_1.default.SET_USER_DONE)];
            case 1:
                payload = (_a.sent()).payload;
                user = payload;
                return [4 /*yield*/, effects_1.call(Analytics_1.setTrackingUserId, user.id)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var userLoginSagas = {
    watchTopMenuLoginClick: watchTopMenuLoginClick,
    watchLoginCloseClick: watchLoginCloseClick,
    watchTogglePanelActive: watchTogglePanelActive,
    watchLoginSubmit: watchLoginSubmit,
    watchOnFacebookLogin: watchOnFacebookLogin,
    watchLoginUploadSaveSearchFromLocalStorageSaga: watchLoginUploadSaveSearchFromLocalStorageSaga,
    watchLoginCloseClickClearEmailSaga: watchLoginCloseClickClearEmailSaga,
    watchUserLoginInitTrackingUserId: watchUserLoginInitTrackingUserId
};
exports.userLoginSagas = userLoginSagas;
